<section class="sdmf-analysis" data-testid="sdmf-analysis">
  <div *ngIf="!canAuthor()" class="sdmf-state info" data-testid="sdmf-readonly">
    SDMF capture is unavailable or outside your authoring access. Authorized
    saved history remains read only.
  </div>

  <div
    *ngIf="isLoading()"
    class="sdmf-state loading"
    data-testid="sdmf-loading"
  >
    Loading SDMF analysis…
  </div>

  <div
    *ngIf="loadError() as error"
    class="sdmf-state error"
    role="alert"
    data-testid="sdmf-load-error"
  >
    {{ error }}
    <button type="button" (click)="retryLoad()">Retry analysis</button>
  </div>

  <div
    *ngIf="saveError() as error"
    class="sdmf-state error"
    data-testid="sdmf-save-error"
  >
    {{ error }}
    <button
      *ngIf="uncertain()"
      type="button"
      [disabled]="isSaving()"
      (click)="retryUncertain()"
    >
      Retry same action
    </button>
  </div>

  <div *ngIf="isSaving()" class="sdmf-state saving" data-testid="sdmf-saving">
    Saving…
  </div>

  <div
    *ngIf="!isSaving() && lastSavedAt() as savedAt"
    class="sdmf-state saved"
    data-testid="sdmf-saved"
  >
    Analysis saved {{ savedAt | date: "shortTime" }}
  </div>

  <p
    *ngIf="savedAnalysis() as saved"
    class="sdmf-saved-reference"
    data-testid="sdmf-saved-summary"
  >
    Analysis #{{ saved.id }} &middot; {{ operationalText.status() }}:
    <span data-testid="sdmf-summary-status">{{ saved.statusCode }}</span>
  </p>

  @if (isLoaded() && scheduledProceedingId && !loadError()) {
    <phms-sdmf-audit [read]="auditRead" [sourceKey]="auditSourceKey()" />
  }
  <div class="sdmf-form" data-testid="sdmf-form">
    <phms-sdmf-analysis-editor
      [ratings]="ratings()"
      [notes]="notes()"
      [summaryNarrative]="summaryNarrative()"
      [editable]="canEdit()"
      [expansion]="expanded()"
      (ratingChange)="setRating($event.factorCode, $event.ratingCode)"
      (noteChange)="setNote($event.factorCode, $event.value)"
      (summaryChange)="setSummary($event)"
      (expansionChange)="expanded.set($event)"
    />
    <div *hearingPhaseBar="'actions'" class="sdmf-actions">
      <button
        type="button"
        class="sdmf-save"
        [disabled]="!canSave()"
        (click)="save()"
        data-testid="sdmf-save"
      >
        {{ savedAnalysis() ? "Save draft" : "Save analysis" }}
      </button>
      <button type="button" [disabled]="!canComplete()" (click)="complete()">
        Complete analysis
      </button>
      <button
        *ngIf="savedAnalysis()?.isCertified"
        type="button"
        [disabled]="!canAuthor() || isSaving()"
        (click)="reopen()"
      >
        Reopen as draft
      </button>
      <button
        *ngIf="dirty() || stale()"
        type="button"
        [disabled]="isSaving() || uncertain()"
        (click)="discardAndReload()"
      >
        Discard edit and reload
      </button>
      <p *ngIf="!savedAnalysis()?.isCertified">
        Completion requires all 13 rated factors on their permitted scales and a
        summary narrative. Save changes before completing.
      </p>
    </div>
  </div>
</section>
